import { queryClient } from '@/lib/react-query';
import { useUpdateMutationFactory, UseUpdateMutationProps } from '@/lib/react-query/update';
import { Task } from '@/types';
import { post } from '@/utils/api';
import { featureKeys, featurePath } from '.';

export type UpdateTaskDTO = { task: Task };

const uncompleteTask = ({ task }: UpdateTaskDTO) =>
  post<Task>(`${featurePath}/${task.task_id}/uncomplete`, {}, {});

export const useUncompleteTask = (options?: UseUpdateMutationProps<Task>) => {
  return useUpdateMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: uncompleteTask,
    onSuccess: (data) => {
      if (data.parent_task_id !== null) {
        queryClient.invalidateQueries({
          queryKey: [{ scope: 'task', entity: 'detail', id: data.parent_task_id }],
        });
        if (data.parent_task?.taskable_type && data.parent_task?.taskable_id) {
          queryClient.invalidateQueries({
            queryKey: [
              {
                scope: data.parent_task.taskable_type,
                entity: 'detail',
                id: data.parent_task.taskable_id,
              },
            ],
          });
        }
      }
    },
    ...options,
  });
};
